/**
 * Program Highlight
 *
 * Home's program list links to the Programs page with a per-program anchor
 * (#program-<slug>, see front-page.php/page-programs.php). On arrival,
 * scrolls the matching card into view and pulses its border to a highlight
 * color (see .prog2--selected, _program-cards.scss), then fades back to
 * normal — a one-time visual cue tying the card back to whichever program
 * the visitor picked on Home.
 */

const HASH_PREFIX = '#program-';
const HIGHLIGHT_CLASS = 'prog2--selected';
const HIGHLIGHT_HOLD_MS = 4400;

export function initProgramHighlight(): void {
  const hash = window.location.hash;
  if (!hash.startsWith(HASH_PREFIX)) return;

  const card = document.querySelector<HTMLElement>(hash);
  if (!card) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  card.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  card.classList.add(HIGHLIGHT_CLASS);

  window.setTimeout(() => {
    card.classList.remove(HIGHLIGHT_CLASS);
  }, HIGHLIGHT_HOLD_MS);
}
